import { useCallback } from "react";
import StatusBar16ProMax from "../components/StatusBar16ProMax";
import ChatItems from "../components/ChatItems";
import { useNavigate } from "react-router-dom";
import HomeIndicator from "../components/HomeIndicator";

const SettingWifiDone = () => {
  const navigate = useNavigate();

  const onHngDnSClick = useCallback(() => {
    navigate("/6-introduction");
  }, [navigate]);

  return (
    <div className="w-full relative bg-light-primary-key-background overflow-hidden flex flex-col items-start justify-start gap-[59px] leading-[normal] tracking-[normal]">
      {/* <StatusBar16ProMax
        statusBar16ProMaxBackgroundColor="#fff"
        statusBar16ProMaxPosition="unset"
        statusBar16ProMaxTop="unset"
        statusBar16ProMaxLeft="unset"
      /> */}
      <main className="self-stretch flex flex-row items-start justify-start pt-0 px-10 pb-[18px] box-border max-w-full">
        <section className="flex-1 flex flex-col items-start justify-start gap-10 max-w-full text-left text-base text-light-text font-text-regular-lowercase mq330:gap-5">
          <div className="relative font-medium">Home</div>
          <ChatItems />
          <div className="self-stretch flex flex-row items-start justify-center py-0 pl-5 pr-[29px] text-center">
            <div className="flex flex-col items-start justify-start gap-8">
              <div className="relative font-medium whitespace-pre-wrap">
                + Thêm thiết bị mới
              </div>
              <div className="flex flex-row items-start justify-start py-0 pl-px pr-0.5">
                <div
                  className="w-[152px] relative font-semibold text-transparent !bg-clip-text [background:linear-gradient(90deg,_#ff92d7,_#ffbc92)] [-webkit-background-clip:text] [-webkit-text-fill-color:transparent] inline-block cursor-pointer"
                  onClick={onHngDnSClick}
                >
                  Hướng dẫn sử dụng
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      {/* <HomeIndicator
        homeIndicatorBackgroundColor="#fff"
        homeIndicatorMargin="unset"
        homeIndicatorPosition="unset"
        homeIndicatorRight="unset"
        homeIndicatorBottom="unset"
        homeIndicatorLeft="unset"
        homeIndicatorTop="unset"
        homeIndicatorMarginTop="unset"
      /> */}
    </div>
  );
};

export default SettingWifiDone;
